import BaseApi from "../base";

export default class Organization extends BaseApi {

}

